import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { VariableFilter } from "./VariableFilter";
import { VariableList } from "./VariableList";

export function VariableDialog({
  open,
  onClose,
  searchTerm,
  setSearchTerm,
  categories,
  activeTab,
  setActiveTab,
  variables,
  onSelect,
  theme,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          height: "550px",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        },
      }}
    >
      <Box sx={{ p: 2.5, display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h6" sx={{ fontWeight: 800 }}>
          Variáveis
        </Typography>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <VariableFilter
        {...{
          searchTerm,
          setSearchTerm,
          categories,
          activeTab,
          setActiveTab,
          theme,
        }}
      />

      <DialogContent
        sx={{
          flex: 1,
          overflowY: "auto",
          backgroundColor: "#fafafa",

          scrollbarWidth: "thin",
          scrollbarColor: "#898989 transparent",

          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#898989",
            borderRadius: "8px",
          },
        }}
      >
        <VariableList variables={variables} onSelect={onSelect} theme={theme} />
      </DialogContent>
    </Dialog>
  );
}
